const sidebar = document.querySelector(".sidebar");

document.addEventListener('DOMContentLoaded', () => {
    const currentPath = window.location.pathname;
    const links = document.querySelectorAll('.sidebar-links a');
    console.log(currentPath, )
    console.log(links)
    links.forEach(link => {
        if (link.getAttribute('href') == currentPath) {
            console.log(link.getAttribute('href'))
            link.parentElement.classList.add('active');
        }
    });
});